import { gql } from '@apollo/client';
import { ReplayStop, ReplayMetricsFields, REPLAY_STOP_FIELDS } from './types';

export interface ReplayManualVersion extends ReplayMetricsFields {
    id: number;
    dspTaskId: number;
    versionNo: number;
    stops: ReplayStop[]; // 载入重排用
    savedById?: number | null;
    savedByName?: string | null;
    savedAt: string;
}

export interface ListReplayManualVersionsResponse {
    listReplayManualVersions: ReplayManualVersion[];
}

export interface ListReplayManualVersionsVariables {
    dspTaskId: number;
}

export const LIST_REPLAY_MANUAL_VERSIONS = gql`
    query ListReplayManualVersions($dspTaskId: Long!) {
        listReplayManualVersions(dspTaskId: $dspTaskId) {
            id
            dspTaskId
            versionNo
            totalDistanceKm
            totalDurationMinutes
            leftTurnCount
            uTurnCount
            trafficLightCount
            stops {${REPLAY_STOP_FIELDS}}
            savedById
            savedByName
            savedAt
        }
    }
`;
